<!-- src/app/add-lead-modal/add-lead-modal.component.html -->
<div class="modal-header">
    <h5 class="modal-title">Add New Lead</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  
  <div class="modal-body">
    <div class="lead-type-toggle">
      <div class="btn-group" role="group">
        <button 
          type="button" 
          class="btn" 
          [ngClass]="{'btn-primary': leadType === 'Entity', 'btn-outline-primary': leadType !== 'Entity'}"
          (click)="toggleLeadType('Entity')">
          Entity
        </button>
        <button 
          type="button" 
          class="btn" 
          [ngClass]="{'btn-primary': leadType === 'Lawyer', 'btn-outline-primary': leadType !== 'Lawyer'}"
          (click)="toggleLeadType('Lawyer')">
          Lawyer
        </button>
      </div>
    </div>
    
    <form [formGroup]="leadForm" (ngSubmit)="submitForm()">
      <div class="row mt-3">
        <!-- Common fields -->
        <div class="col-md-6 mb-3" *ngIf="leadType !== 'Entity'">
          <label for="name" class="form-label">Name <span class="spano">*</span></label>
          <input type="text" spellcheck="false" class="form-control" id="name" formControlName="name"
          (input)="sanitizeInput($event,'name')" autocomplete="off" autocorrect="off">
          <div *ngIf="leadForm.get('name')?.invalid && leadForm.get('name')?.touched" class="text-danger">
            Name is required
          </div>
        </div>

        <div class="col-md-6 mb-3" *ngIf="leadType === 'Entity'">
          <label for="firmName" class="form-label">Firm Name <span class="spano">*</span></label>
          <input type="text" class="form-control" id="firmName" formControlName="firmName"
          (input)="sanitizeInput($event,'firmName')" autocomplete="off" autocorrect="off">
          <div *ngIf="leadForm.get('firmName')?.invalid && leadForm.get('firmName')?.touched" class="text-danger">
            Firm name is required
          </div>
        </div>
        
        <div class="col-md-6 mb-3">
          <label for="firmEmail" class="form-label" *ngIf="leadType === 'Entity'">Firm Email Address<span class="spano">*</span></label>
          <label for="firmEmail" class="form-label" *ngIf="leadType != 'Entity'">Email Address<span class="spano">*</span></label>
          <input type="email" class="form-control" id="firmEmail" formControlName="firmEmail"
          (input)="sanitizeInput($event,'email')" autocomplete="off" autocorrect="off">
          <div *ngIf="leadForm.get('firmEmail')?.invalid && leadForm.get('firmEmail')?.touched" class="text-danger">
            Valid firm email is required
          </div>
        </div>

        <!-- <div class="col-md-6 mb-3">
          <label for="email" class="form-label">Email *</label>
          <input type="email" class="form-control" id="email" formControlName="email">
          <div *ngIf="leadForm.get('email')?.invalid && leadForm.get('email')?.touched" class="text-danger">
            Valid email is required
          </div>
        </div> -->
        
        <!-- <div class="col-md-6 mb-3">
          <label for="status" class="form-label">Status <span class="spano">*</span></label>
          <select class="form-select" id="status" formControlName="status">
            <!-- <option value="" disabled>Select Status</option> --
            <option value="New">New</option>
            <option value="Contacted">Contacted</option>
            <option value="Qualified">Qualified</option>
            <option value="Converted">Converted</option>
            <option value="Lost">Lost</option>
          </select>
        </div> -->
        
        <div class="col-md-6 mb-3">
          <label for="specialization" class="form-label">Area of Specialization <span class="spano">*</span></label>
          <select class="form-select" id="specialization" formControlName="specialization">
            <option value="" disabled>Select Specialization</option>
            <option *ngFor="let spec of specializations" [value]="spec">{{ spec }}</option>
          </select>
          <div *ngIf="leadForm.get('specialization')?.invalid && leadForm.get('specialization')?.touched" class="text-danger">
            Specialization is required
          </div>
        </div>
        
        <div class="col-md-6 mb-3">
          <label for="contactNumber" class="form-label">Contact Number</label>
          <input type="text" class="form-control" id="contactNumber" formControlName="contactNumber"
          (input)="sanitizeInput($event,'contactNumber')" autocomplete="off" autocorrect="off">
          <div *ngIf="leadForm.get('contactNumber')?.invalid && leadForm.get('contactNumber')?.touched" class="text-danger">
            Enter a valid 10-digit number
          </div>
        </div>
        
        <!-- Entity specific fields -->
        <ng-container *ngIf="leadType === 'Entity'">
          <div class="col-md-6 mb-3">
            <label for="registrationNumber" class="form-label">Registration Number (TIN)<span class="spano">*</span></label>
            <input type="text" class="form-control" id="registrationNumber" formControlName="registrationNumber"
            (input)="sanitizeInput($event,'registrationNumber')" autocomplete="off" autocorrect="off">
            <div *ngIf="leadForm.get('registrationNumber')?.invalid && leadForm.get('registrationNumber')?.touched" class="text-danger">
              Registration number (TIN) is required
            </div>
          </div>
          
          <div class="col-md-6 mb-3">
            <label for="contactPerson" class="form-label">Contact Person</label>
            <input type="text" class="form-control" id="contactPerson" formControlName="contactPerson"
            (input)="sanitizeInput($event,'contactPerson')" autocomplete="off" autocorrect="off">
          </div>
          
          <div class="col-md-6 mb-3">
            <label for="designation" class="form-label">Designation</label>
            <input type="text" class="form-control" id="designation" formControlName="designation"
            (input)="sanitizeInput($event,'designation')" autocomplete="off" autocorrect="off">
          </div>
          
          <div class="col-md-6 mb-3">
            <label for="numberOfLawyers" class="form-label">Number of Lawyers</label>
            <input type="number" min="0" class="form-control" id="numberOfLawyers" formControlName="numberOfLawyers" min="0"
            (input)="sanitizeInput($event,'numberOfLawyers');onInput($event);restrictFirstPosition($event)" autocomplete="off" autocorrect="off">
          </div>
          
          <!-- <div class="col-md-12 mb-3">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="needLawyerDetails" formControlName="needLawyerDetails">
              <label class="form-check-label" for="needLawyerDetails">
                Need details of individual lawyers
              </label>
            </div>
          </div> -->
        </ng-container>
        
        <!-- Lawyer specific fields -->
        <ng-container *ngIf="leadType === 'Lawyer'">
          <div class="col-md-6 mb-3">
            <label for="licenseNumber" class="form-label">License Number <span class="spano">*</span></label>
            <input type="text" class="form-control" id="licenseNumber" formControlName="licenseNumber"
            (input)="sanitizeInput($event,'licenseNumber')" autocomplete="off" autocorrect="off">
            <div *ngIf="leadForm.get('licenseNumber')?.invalid && leadForm.get('licenseNumber')?.touched" class="text-danger">
              License number is required
            </div>
          </div>
        </ng-container>
        
        <div class="col-md-6 mb-3">
          <label for="address" class="form-label">Address</label>
          <textarea class="form-control" id="address" rows="2" formControlName="street" (input)="sanitizeInput($event,'street')" autocomplete="off" autocorrect="off"></textarea>
        </div>

        <!-- 🆕 Address Fields Section -->
        <!-- <div class="col-md-6 mb-3">
          <label for="addressType" class="form-label">Address Type</label>
          <select class="form-select" id="addressType" formControlName="addressType">
            <option value="Home">Home</option>
            <option value="Office">Office</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div class="col-md-6 mb-3">
          <label for="houseFlatNo" class="form-label">House/Flat No</label>
          <input type="text" class="form-control" id="houseFlatNo" formControlName="houseFlatNo">
        </div>

        <div class="col-md-6 mb-3">
          <label for="street" class="form-label">Street</label>
          <input type="text" class="form-control" id="street" formControlName="street">
        </div>

        <div class="col-md-6 mb-3">
          <label for="landmark" class="form-label">Landmark</label>
          <input type="text" class="form-control" id="landmark" formControlName="landmark">
        </div>

        <div class="col-md-6 mb-3">
          <label for="city" class="form-label">City/Town</label>
          <input type="text" class="form-control" id="city" formControlName="city">
        </div>

        <div class="col-md-6 mb-3">
          <label for="state" class="form-label">State</label>
          <input type="text" class="form-control" id="state" formControlName="state">
        </div> -->

        <div class="col-md-6 mb-3">
          <label for="country" class="form-label">Country <span class="spano">*</span></label>
          <!-- <input type="text" class="form-control" id="country" formControlName="country"> -->
          <select class="form-select" id="country" formControlName="country">
            <!-- <option value="" disabled selected>Select a country</option> -->
            <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
          </select>
        </div>

        <div class="col-md-6 mb-3">
          <label for="zipcode" class="form-label">Zip Code</label>
          <input type="text" class="form-control" id="zipcode" formControlName="zipcode"
          (input)="sanitizeInput($event,'zipcode')" autocomplete="off" autocorrect="off">
        </div>

        <div class="col-md-12 mb-3">
          <label for="additionalDetails" class="form-label">Additional Details</label>
          <textarea maxlength="200" class="form-control" id="additionalDetails" rows="3" formControlName="additionalDetails" (input)="sanitizeInput($event,'additionalDetails')" autocomplete="off" autocorrect="off"></textarea>
          <div class="count-div">
          <div class="count-text">
             {{ leadForm.get('additionalDetails')?.value?.length || 0 }}/200
          </div>
        </div>
        </div>
      </div>
    </form>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="submitForm()">Save</button>
  </div>